// The single-choice booking steps (service category, service, duration,
// time, package time slots) move on as soon as a card is picked, so their
// "Conferma" / "Avanti" button is hidden. It stays in the code on purpose:
// set this to true to bring it back on every one of those steps. The guests,
// calendar and upselling steps always keep their buttons.
export const SHOW_CONFIRM_ON_AUTO_ADVANCE_STEPS = false;
